<template>
    <section class="team-add-bulk-student-view">
        <h3>Add Bulk Students To Team</h3>
        <p>Enter a list of student identifiers separated by either a comma or a new line.<small>* 500 student limit at a time</small></p>
        
        <app-form 
            ref="bulkForm"
            :model="bulk"
            @submit.native.prevent="handleBulkAddStudents">

            <app-alert v-if="error" type="error">{{ error }}</app-alert>

            <app-form-item label="Student Identifiers" prop="student_identifiers">
                <app-input 
                    id="student_identifiers"
                    v-model="bulk.students" 
                    type="textarea" 
                    placeholder="1234, 5678, 9012..." />
            </app-form-item>

            <div class="modal-footer">
                <app-button
                    :loading="isSaving"
                    type="primary"
                    native-type="submit"
                    size="large">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import Team from '@/store/models/Team'

export default {
    name: 'team-add-bulk-student-view',
    inject: ['modalOptions'],
    props: ['team_id'],
    data() {
        return {
            students: [],
            query: '',
            showAddBulk: false,
            bulk: {
                students: ''
            },
            isSaving: false,
            error: null
        }
    },
    methods: {
        handleBulkAddStudents() {
            const students = this.bulk.students.split(/[\s,]+/)
            if (students.count > 500) {
                this.error = 'Too many student identifiers, please limit to 500.'
                return
            }
            Team.$mutate({
                graphql: 'bulkAttachStudents',
                variables: {
                    team_id: this.team_id,
                    student_school_ids: students
                }
            }).then(() => {
                this.$notify({
                    title: 'Success',
                    message:
                        'The students have been added successfully to the team.',
                    type: 'success',
                    offset: 75,
                    duration: 5000
                })
                this.$emit('reload')
                this.modalOptions.modalOpen = false
            })
            return false
        }
    }
}
</script>

<style lang="stylus" scoped>
small
    display: block
    padding-top: 10px
</style>
